
export const findEntityRecursively = (entities, id, depth) => entities && entities.reduce((found, entity) => {
	if(found)
		return found;
	
	depth = depth ?? 0;

	if(entity.Id == id)
		return { 
			depth: depth,
			match: entity,
			[depth]: entity
		};
	
	if(!entity.Entities || !(entity.Entities.length > 0)) 
		return false;

	const match = findEntityRecursively(entity.Entities.map(related => related.Entity), id, depth + 1);
	if(!match) 
		return false;

	match[depth] = entity;

	return match;
}, false);
